enum ItemSellingType {
  OnSale = 'OnSale',
  OnEnglishAuction = 'OnEnglishAuction',
  OnDutchAuction = 'OnDutchAuction',
}

export default ItemSellingType;
